<template>
  <div class="home">
    <Header style="background-color: #EFF1F5"></Header>
    <Banner></Banner>
    <IndexOffers router="this.$router"></IndexOffers>
    <HowItWorks></HowItWorks>
    <WhyUs></WhyUs>
    <Footer></Footer>
  </div>
</template>
<style src="@/assets/client/css/main.css"></style>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Banner from "@/components/Banner.vue";
import IndexOffers from "@/components/IndexOffers.vue";
import HowItWorks from "@/components/HowItWorks.vue";
import WhyUs from "@/components/WhyUs.vue";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    Banner,
    IndexOffers,
    HowItWorks,
    WhyUs
  }
};
</script>
